<template>
  <div class="serials hideScrollbar">
    <div>
      <div v-for="(itemC,indexC) in serials_category" :key="indexC">
        <div class="category">
          {{itemC}}
        </div>
        <ul v-for="(itemS,indexS) in serials" :key="indexS">
          <li class="item" v-if="itemS.serials_category==itemC">
            <div @click="openStandards(itemS)">{{itemS.standards_code}}</div>
            <div>
              <span @click="openStandards(itemS)">
                <span v-if="itemS.standards_name2">
                  {{itemS.standards_name2}}&nbsp;&nbsp;&nbsp;---&nbsp;&nbsp;&nbsp;
                </span>
                <span>{{itemS.standards_name}}</span>
              </span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span @click="downloadStandards(itemS)" class="icon">
                <font-awesome-icon icon="arrow-alt-circle-down" />
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  export default {
    name: "serials",
    computed: {
      showPayment() {
        return this.$store.state.payment.showPayment;
      },
      serials() {
        return this.$store.state.standards.serials;
      },
      serials_category() {
        var temp = []
        if (this.serials && this.serials.length > 0) {
          for (var i = 0; i < this.serials.length; i++) {
            if (temp.indexOf(this.serials[i].serials_category) == -1) {
              temp.push(this.serials[i].serials_category)
            }
          }
        }
        return temp
      }
    },
    methods: {
      openStandards(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/showStandards",
          query: {
            standards_code: params.standards_code,
            standards_name: params.standards_name,
            related_standards_code: params.related_standards_code,
            serials: params.serials
          }
        });
        window.open(href, "_blank");
      },
      downloadStandards(params) {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false);
        this.$store.dispatch("order/setRechargeInfo", 5000);
        this.$store.dispatch("order/setOnceInfo", {
          order_number: new Date().getTime(),
          description: params.standards_code + " " + params.standards_name,
          category: "standards_download",
          code: params.standards_code,
          total_fee: 98, //单位分
          body: "标准下载" // 发给微信端的订单描述
        });
      }
    }
  };
</script>

<style scope>
  .serials {
    height: calc(100vh - 2.2rem);
  }

  .serials .category {
    width: 0.6rem;
    margin-top: 0.1rem;
    color: #2f2f2f;
    font-weight: 900;
    border-bottom: 1px solid #2f2f2f
  }

  .serials ul {
    margin-left: 0.15rem;
    padding-left: 0rem;
  }

  .serials .item {
    margin-top: 0.1rem;
    margin-left: 0;
    padding-left: 0;
  }

  .serials .item:hover {
    color: black;
    background-color: #ccc;
    cursor: pointer;
  }

  .serials .icon:hover {
    color: #aa0000;
    cursor: pointer;
  }
</style>